import moment from "moment";
import { useQueryClient } from "react-query";
import styled, { css } from "styled-components";
import { getFaultsList } from "shared/helpers/helpers";
import { useLocations } from "shared/hooks";
import { ssrStateKey } from "shared/hooks/useSsrState";
import { mergeSsrStateIntoFlat, EMPTY_SSR_STATE } from "shared/helpers/ssrCache";
import { thermocoupleSettingKey } from "shared/hooks/useReceivedThermocoupleSetting";
import { EMPTY_THERMOCOUPLE_SETTING } from "shared/helpers/thermocoupleCache";
import {
  justifyContentFlexStart,
  justifyContentSpaceBetween,
  layerA180Deg,
  layerBDark,
} from "shared/styles/commonStyles";

const FaultsReport = ({
  isReportStatus,
  swt,
  locationData,
  specificLocation,
}) => {

  const locations = useLocations();
  const queryClient = useQueryClient();

  const mergedLocationData = mergeSsrStateIntoFlat(
    locationData,
    (mac) => queryClient.getQueryData(ssrStateKey(mac)) || EMPTY_SSR_STATE
  );
  const faultsArray = getFaultsList(mergedLocationData)?.map((fault) => {
    console.log({fault},"FaultsReport")



    const receivedThermocoupleSetting =
      queryClient.getQueryData(thermocoupleSettingKey(fault.machine)) ||
      EMPTY_THERMOCOUPLE_SETTING;
    const locationName = locations[swt][fault.location].locationName;



    const machineName = locations[swt][fault.location].devices[fault.machine].machineName;
    const time = receivedThermocoupleSetting.find(
      (item) => item.tc_no === fault.number[0] - 1
    )?.time;
    const faultDate = fault.date
      ? ` - ${fault.date}`
      : fault.faultType === "thermocouple fault" && swt !== "tgs"
      ? ` - ${time ? moment.unix(time).format("h:mma - DD/MM/YYYY") : ""}`
      : "";

    return {
      fault: `${fault.faultType} ${fault.number}`,
      message: `${swt} - ${locationName} - ${machineName} ${faultDate}`,
    };
  });
  if (faultsArray.length > 0) {
    return (
      <Wrapper isReportStatus={isReportStatus}>
        <SectionHeader>
          <HeaderTitle>faults report</HeaderTitle>
        </SectionHeader>
        <SectionContent>
          {faultsArray.map((elem) => (
            <DisplayFaults key={JSON.stringify(elem)}>
              <FaultsMessage>{elem.message}</FaultsMessage>
              <Faults>{elem.fault}</Faults>
            </DisplayFaults>
          ))}
        </SectionContent>
      </Wrapper>
    );
  }
};

export default FaultsReport;

const Wrapper = styled.div`
  width: 544px;
  border-radius: 18px;
  ${layerA180Deg}

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 3px 0;
  margin-left: 500px;
  ${({ isReportStatus }) =>
    isReportStatus &&
    css`
      position: absolute;
      right: 0px;
      top: 50px;
      border: 1px solid red;
      z-index: 1000;
    `}
`;
const SectionHeader = styled.section`
  width: 535px;
  height: 29px;

  border-radius: 15px;
  ${layerBDark};
  ${justifyContentFlexStart};
  padding: 0 12px;
`;
const HeaderTitle = styled.span`
  width: 100%;
  text-align: left;
  font-size: 12px;
  letter-spacing: 1.2px;
  color: #fe0000;
`;
const SectionContent = styled.section`
  width: 535px;
  border-radius: 8px;
  margin-top: 6px;
  ${layerBDark}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
`;
const DisplayFaults = styled.div`
  width: 530px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid #233a54;

  ${justifyContentSpaceBetween}

  margin-bottom: 2px;
  &:last-child {
    margin-bottom: 0px;
  }

  padding: 0 10px;
`;
const Faults = styled.span`
  color: #fe0000;
  font-size: 10px;
  text-align: right;
`;
const FaultsMessage = styled.span`
  font-size: 10px;
  text-align: left;
`;
